import { useEffect } from "react";

export default function ConfirmModal({ title, message, onConfirm, onCancel }) {
  useEffect(() => {
    const onEsc = (e) => { if (e.key === "Escape") onCancel(); };
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [onCancel]);

  return (
    <div className="confirm-backdrop" onClick={onCancel} data-testid="confirm-modal">
      <div className="confirm-box" onClick={(e) => e.stopPropagation()}>
        <h4>{title}</h4>
        <p>{message}</p>
        <div className="row">
          <button className="btn btn-outline btn-sm" onClick={onCancel} data-testid="confirm-cancel">
            Cancelar
          </button>
          <button className="btn btn-primary btn-sm" onClick={onConfirm} data-testid="confirm-ok">
            Sí, continuar
          </button>
        </div>
      </div>
    </div>
  );
}
